export const reportPaths = {
  REPORT: "",
  REPORT_ADDITIONAL_CHARGE: "additional-charge",
  REPORT_INVENTORY: "inventory",
  REPORT_CATEGORY: "category",
  REPORT_DISCOUNT: "discount",
  REPORT_VOUCHER: "voucher",
  REPORT_SALES: "sales",
  REPORT_TIP: "tip",
  REPORT_FREE_CREDITS: "free-credits",
  REPORT_ACCESS_CONTROL: "access-control",
  REPORT_ARRIVAL_TIME: "arrival-time",
  REPORT_ON_GROUND: "on-ground",
  REPORT_DUPLICATE_TICKETS: "duplicate-tickets",
  REPORT_GUEST_REFUND: "guest-refund",
  REPORT_REFUND_CLAIM: "refund-claims",
  UNSYNC_TRANSACTION:"unsync-transactions",
  MONTHLY_SALE_REPORT:"monthly-sale-report"
};
